export const getSelectedOptionsSkus = (selectedOptions) => {
  const selectedOptionsSkus = new Map();

  selectedOptions?.forEach((selectedOption) => {
    let optionQty = selectedOption?.value;

    if (optionQty === undefined) {
      optionQty = selectedOption?.size?.sizeCode === 'no' ? 0 : 1;
    }

    selectedOptionsSkus.set(selectedOption.size.sku, {
      quantity: optionQty,
    });
  });

  return selectedOptionsSkus;
};
